import { render } from "./Teachers.vue?vue&type=template&id=f3985536&scoped=true"
import script from "./Teachers.vue?vue&type=script&lang=js"
export * from "./Teachers.vue?vue&type=script&lang=js"

import "./Teachers.vue?vue&type=style&index=0&id=f3985536&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3985536"]])

export default __exports__